import ModalViewModel from 'infra/ModalViewModel'
import { required, validationContext } from 'validx'
import { action, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import Job from '../../../../Job'
import JobStore from '../../../../JobStore'
import { AlertFactory, AlertState } from '../../../../../alerts/Alert'

export class AddManualInvoiceDialogViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private jobStore: JobStore,
    private alertFactory: AlertFactory,
  ) {
    super()

    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  @observable
  reason = ''

  @observable
  stripeId = ''

  @observable
  invoiceAmount = 0

  validation = validationContext(this, {
    reason: [required('A reason is required')],
    stripeId: [required('Stripe Id is required')],
    invoiceAmount: [
      required('Invoice amount is required'),
      (opts) => opts.value !== 0 || 'Amount cannot be 0',
    ],
  })

  @action.bound
  validate() {
    return this.validation.reset().validate().isValid
  }

  add = task.resolved(async () => {
    if (!this.validate()) {
      return
    }

    const alert = this.alertFactory()
      .withState(AlertState.Pending)
      .saying('Adding Invoice', 'Hang tight!')
      .show()

    try {
      await this.jobStore.addManualInvoice(
        this.job.id,
        this.stripeId,
        this.invoiceAmount,
        this.reason,
        this.job.status === 'UNDER_CONSTRUCTION',
      )

      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Invoice has been added!')

      this.close()
    } catch (e) {
      console.error(e)

      alert.withState(AlertState.Error).fromError(e).autoDismiss()
    }
  })

  @action.bound
  reset() {
    this.reason = ''
    this.stripeId = ''
    this.invoiceAmount = 0
  }
}
